import { enqueueSnackbar, DownloadFile } from 'actions';

import { RanReportRFRequest, RanReportRFClusterDailyRequest, RanReportRFClusterHourlyRequest } from '../requests/RanReportRFRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const SET_FORM_STATE_CLUSTER = 'SET_FORM_STATE_CLUSTER';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

const onSetFormStateCluster = (value) => ({
	type: SET_FORM_STATE_CLUSTER,
	formStateCluster: value
});

export const SetFormStateCluster = (value) => (dispatch) => {
	dispatch(onSetFormStateCluster(value));
};

export const RanReportRF = (values, userId) => async (dispatch) => {
	await RanReportRFRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RanReportRFClusterDaily = (values, userId) => async (dispatch) => {
	await RanReportRFClusterDailyRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const RanReportRFClusterHourly = (values, userId) => async (dispatch) => {
	await RanReportRFClusterHourlyRequest(values, userId).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
